// start:ng42.barrel
export * from './IAkamaiCookie';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/AkamaiCookie/index.ts